export class Base64EncoderService {
  encode(data) {
    return btoa(data);
  }
}
